/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

import { style } from 'typestyle';

export function mainStyles(themedColors: any) {
  return {
    common: {
      backdrop: style({
        fontFamily: "Segoe UI",
        backgroundColor: themedColors.background,
        borderRadius: '0px',
        padding: '32px 50px',
        height: 'calc(100vh - 2*32px)',
        overflow: 'auto'
      }),
      title: style({
        color: themedColors.mainTitleColor,
        fontSize: '24px',
        fontWeight: 'bold',
        letterSpacing: '0px',
        marginBottom: '8px',
      }),
      subTitle: style({
        maxWidth: '700px',
        color: themedColors.mainTextColor,
        fontSize: '14px',
        letterSpacing: '0px',
        marginBottom: '19px',
      }),
    },
    tabs: {
      common: style({
        marginTop: '24px',
        minWidth: '225px',
      }),
      btnContainer: style({
        $nest: {
          'button[role=tab]': {
            width: '151px',
            height: '32px',
            borderRadius: '0px',
            background: 'rgb(245, 245, 245)'
          },
          'button[aria-selected=false]:hover': {
            color: 'rgb(37, 36, 36)',
          },
          'button:focus': {
            outline: "2px black solid"
          },
          "button[aria-selected=true]": {
            width: '151px',
            height: '32px',
            borderRadius: '0px',
            background: '#6264a7'
          },
        }
      }),
    }
  }
}
